import { UntilDestroy } from '@ngneat/until-destroy'
import { Component } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionModule } from '@angular/material/expansion'
import { TranslocoModule } from '@jsverse/transloco'

@UntilDestroy()
@Component({
    selector: 'app-template-selector',
    templateUrl: './template-selector.component.html',
    imports: [TranslocoModule, MatExpansionModule, MatIconModule],
})
export class TemplateSelectorComponent {}
